import { useQuery } from "@tanstack/react-query";
import { Megaphone } from "lucide-react";
import { api } from "@/lib/api";

export function SiteAnnouncements() {
  const { data = [] } = useQuery({ queryKey: ["site-announcements"], queryFn: () => api.get("/announcements/site").then((r) => r.data.items), staleTime: 300000 });
  if (!data.length) return null;
  const a = data[0];
  return (
    <div className="relative z-10 border-b border-amber-700/40 bg-amber-950/40 px-4 py-2 text-sm text-amber-100" data-testid="site-announcement-banner">
      <div className="container-x flex items-start gap-2"><Megaphone className="mt-0.5 h-4 w-4 shrink-0 text-amber-300" /><p><strong>{a.title}</strong> — {a.body}</p></div>
    </div>
  );
}
